'use strict';

var util = require('../../../util/property-util');
var arrayUtil = require('../../../util/array-util');
var zabbixUtil = require('./zabbix-util');

module.exports = /*@ngInject*/ ["$http", "$q", "ZabbixResourceService", function ZabbixOverviewFactory($http, $q, ZabbixResourceService) {
    var factory = {
        postAcknowledgement: postAcknowledgement,
        getZabbixToken: getZabbixToken,
        fillPriorities: fillPriorities,
        fillHashCodes: fillHashCodes,
        orderData: orderData,
        makeStructure: makeStructure,
        reloadOldStructure: reloadOldStructure,
        adjustOfflineProxyPriorities: adjustOfflineProxyPriorities,
        calculateCoachSeverity: calculateCoachSeverity,
        customizeTreeStructure: customizeTreeStructure
    };

    return factory;

    /*
     FUNCTIONS
     */

    function postAcknowledgement(projectId, trainId, eventIds, type) {
        var deferred = $q.defer();
        ZabbixResourceService.acknowledge().save({
            projectId: projectId,
            trainId: trainId,
            type: type
        }, eventIds).$promise.then(function (data) {
            deferred.resolve();
        }, function (response) { // error
            deferred.reject();
        });
        return deferred.promise;
    }

    function getZabbixToken(projectId) {
        var deferred = $q.defer();
        ZabbixResourceService.getZabbixToken(projectId).$promise.then(function (data) {
            deferred.resolve(angular.fromJson(data.message));
        });
        return deferred.promise;
    }


    function fillPriorities(structure) {
        "use strict";

        structure.forEach(function (train) {
            var trainSeverity = 0;
            
            train.devices.forEach(function (device) {
                var deviceSeverity = 0;

                device.issues.some(function (issue) {
                    if (issue.severity == -1) {
                        deviceSeverity = -1;
                        return true;
                    } else if (issue.severity > deviceSeverity) {
                        deviceSeverity = issue.severity;
                    }
                });
                device.severity = deviceSeverity;
                if (device.severity == -1) {
                    trainSeverity = -1;
                } else if (deviceSeverity > trainSeverity && trainSeverity != -1) {
                    trainSeverity = deviceSeverity;
                }
            });

            train.deviceGroups.forEach(function (deviceGroup) {
                var deviceGroupSeverity = 0;
                deviceGroup.devices.forEach(function (device) {
                    var deviceSeverity = 0;

                    device.issues.some(function (issue) {
                        if (issue.severity == -1) {
                            deviceSeverity = -1;
                            return true;
                        } else if (issue.severity > deviceSeverity) {
                            deviceSeverity = issue.severity;
                        }
                    });
                    device.severity = deviceSeverity;
                    if (device.severity == -1) {
                        deviceGroupSeverity = -1;
                    } else if (deviceSeverity > deviceGroupSeverity && deviceGroupSeverity != -1) {
                        deviceGroupSeverity = deviceSeverity;
                    }
                });

                deviceGroup.severity = deviceGroupSeverity;
                if (deviceGroup.severity == -1) {
                    trainSeverity = -1;
                } else if (deviceGroupSeverity > trainSeverity && trainSeverity != -1) {
                    trainSeverity = deviceGroupSeverity;
                }
            });

            if (train.onlineStatus) {
                train.severity = trainSeverity;
            } else {
                train.severity = -1;
            }

        });
        return structure;
    }

    function fillHashCodes(structure) {
        "use strict";
        structure.forEach(function (train) {
            if (train) {
                train.hashCode = "P" + train.projectId + "T" + train.trainId;
                if (train.devices) {
                    train.devices.forEach(function (device) {
                        device.hashCode = "H" + device.hostId + "N" + device.hostname;
                    });
                }
                if (train.deviceGroups) {
                    train.deviceGroups.forEach(function (deviceGroup) {
                        deviceGroup.hashCode = "D" + deviceGroup.name.replace(" ", "") + "T" + train.trainId;
                        deviceGroup.devices.forEach(function (device) {
                            device.hashCode = "H" + device.hostId + "N" + device.hostname;
                        });
                    });
                }

            }
        });

        return structure;
    }

    function orderData(structure) {
        "use strict";
        structure.sort(function (a, b) {
            return a.trainId - b.trainId;
        });

        structure.forEach(function (train) {
            train.devices.sort(function (a, b) {
                if (a.hostname < b.hostname) return -1;
                if (a.hostname > b.hostname) return 1;
                return 0;
            });


            train.deviceGroups.forEach(function (deviceGroup) {
                deviceGroup.devices.sort(function (a, b) {
                    if (a.hostname < b.hostname) return -1;
                    if (a.hostname > b.hostname) return 1;
                    return 0;
                });
            });

            train.deviceGroups.sort(function (a, b) {
                var aSplit = a.name.split(" ");
                var bSplit = b.name.split(" ");

                if (aSplit.length == 2 && bSplit.length == 2) {
                    if (Number(aSplit[1]) < Number(bSplit[1])) return -1;
                    if (Number(aSplit[1]) > Number(bSplit[1])) return 1;
                    return 0;
                } else if (aSplit.length == 1 && bSplit.length == 2) {
                    return 1;
                } else if (bSplit.length == 1 && aSplit.length == 2) {
                    return -1;
                } else {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                }


            });


        });


        return structure;
    }

    function makeStructure(structure) {
        "use strict";

        structure.forEach(function (train) {
            var deviceGroupsMap = new Map();
            train.tmpDevices = [];
            train.devices.forEach(function (device) {
                var split = device.hostname.split("_");
                if (split.length === 4 || train.hasDeviceInfo) {
                    var numberString = undefined;

                    // When hasDeviceInfo try to use coachId rather than parse hostName. Will add box into coach.
                    if (train.hasDeviceInfo) {
                        if (!isNaN(device.coachId)) {
                            numberString = device.coachId;
                        } else {
                            train.tmpDevices.push(device);
                        }
                    } else {
                        numberString = split[2].replace("R", "");
                    }

                    var number = Number(numberString);
                    var groupName;
                    if (!isNaN(number)) {
                        groupName = "Coach " + number;

                    } else {
                        groupName = split[2];
                    }

                    var paintedCoachId = "unknown";
                    if (util.isDefined(device.paintedCoachId)) {
                        if (device.paintedCoachId.trim().toLowerCase() !== "unknown") {
                            paintedCoachId = device.paintedCoachId;
                        }
                    }

                    var arr = [];
                    if (deviceGroupsMap.has(groupName)) {
                        arr = deviceGroupsMap.get(groupName).deviceArray;

                    }
                    arr.push(device);

                    let obj = {
                        paintedCoachId: paintedCoachId,
                        deviceArray: arr
                    };

                    deviceGroupsMap.set(groupName, obj);
                } else {
                    train.tmpDevices.push(device);
                }
            });
            train.allDevices = train.devices;
            train.devices = train.tmpDevices;
            train.deviceGroups = [];
            deviceGroupsMap.forEach(function (value, key) {
                var object = {
                    name: key,
                    trainId: train.trainId,
                    devices: value.deviceArray,
                    paintedCoachId: value.paintedCoachId
                };
                train.deviceGroups.push(object);
            });
        });

        return structure;
    }

    function reloadOldStructure(oldStructure, newStructure) {
        "use strict";

        newStructure.forEach(function (train) {
            var foundTrain = undefined;

            oldStructure.some(function (oldTrain) {
                if (oldTrain.trainId === train.trainId) {
                    foundTrain = oldTrain;
                    return true;
                }
            });

            if (util.isDefined(foundTrain)) {
                foundTrain.severity = train.severity;
                foundTrain.onlineStatus = train.onlineStatus;
                foundTrain.trainAlarmAckStyle = train.trainAlarmAckStyle;

                train.devices.forEach(function (device) {
                    var foundDevice = undefined;

                    foundTrain.devices.some(function (oldDevice) {
                        if (oldDevice.hostname === device.hostname) {
                            foundDevice = oldDevice;
                            return true;
                        }
                    });

                    if (util.isDefined(foundDevice)) {
                        foundDevice.severity = device.severity;
                        foundDevice.issues = device.issues;
                        foundDevice.alarmAckStyle = device.alarmAckStyle;

                    } else {
                        foundTrain.devices.push(device);
                    }
                });

                train.allDevices.forEach(function (device) {
                    var foundDevice = undefined;

                    foundTrain.allDevices.some(function (oldDevice) {
                        if (oldDevice.hostname === device.hostname) {
                            foundDevice = oldDevice;
                            return true;
                        }
                    });

                    if (util.isDefined(foundDevice)) {
                        foundDevice.severity = device.severity;
                        foundDevice.issues = device.issues;
                        foundDevice.alarmAckStyle = device.alarmAckStyle;

                    } else {
                        foundTrain.devices.push(device);
                    }
                });


                train.deviceGroups.forEach(function (group) {
                    var foundGroup = undefined;

                    foundTrain.deviceGroups.some(function (oldGroup) {
                        if (oldGroup.name === group.name) {
                            foundGroup = oldGroup;
                            return true;
                        }
                    });

                    if (util.isDefined(foundGroup)) {
                        foundGroup.severity = group.severity;
                        foundGroup.alarmAckStyle =  group.alarmAckStyle;
                        group.devices.forEach(function (device) {
                            var foundDevice = undefined;

                            foundGroup.devices.some(function (oldDevice) {
                                if (oldDevice.hostname === device.hostname) {
                                    foundDevice = oldDevice;
                                    return true;
                                }
                            });

                            if (util.isDefined(foundDevice)) {
                                foundDevice.severity = device.severity;
                                foundDevice.issues = device.issues;
                                foundDevice.alarmAckStyle = device.alarmAckStyle;
                            } else {
                                foundGroup.devices.push(device);
                            }
                        });

                    } else {
                        foundTrain.deviceGroups.push(group);
                    }
                });
            } else {
                oldStructure.push(train);
            }
        });

        return oldStructure;
    }

    function adjustOfflineProxyPriorities(structure) {
        structure.forEach(function (train) {
            if (train.onlineStatus) {
                return;
            }

            if(!angular.isArray(train.devices)){
                console.log("Unable to adjust offline proxy priorities. No devices mapped for this train. Check zabbix location mapping.");
                return;
            }

            train.devices.forEach(function (device) {
                device.issues.forEach(function (issue) {
                    issue.severity = -1;
                });
            });
        });


        return structure;
    }

    function calculateCoachSeverity(structure) {
        var severity = 0;
        var issueLength = 0;
        structure.forEach(function (train) {
            train.deviceGroups.forEach(function (deviceGroup) {
                if (deviceGroup.severity > severity) {
                    severity = deviceGroup.severity;
                }
                deviceGroup.devices.forEach(function (device) {
                    issueLength += device.issues.length;
                });
            });

            train.coachIssues = {
                severity: severity,
                numberOfIssues: issueLength
            }
        });
        return structure;
    }

    function customizeTreeStructure(trainStructure, customZabbixConfig) {
        if (util.isDefined(trainStructure) && util.isDefined(customZabbixConfig)) {
            trainStructure.trainLabel = customZabbixConfig.unitName;
            trainStructure.deviceGroups && trainStructure.deviceGroups.forEach(function (group) {
                var parts = group.name.split("Coach");
                if (parts.length > 1) {
                    var index = parts[1].trim();
                    var customConfig = arrayUtil.getFirstInList(customZabbixConfig.coachNames, "coachNr", index);
                    if (util.isDefined(customConfig)) {
                        group.name = customConfig.customName;
                    }
                }
            });
        }
    }
}];
